var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSalesforce24X18(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 18,
    viewBox: "0 0 24 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M9.98734 1.86398C10.7614 1.04346 11.839 0.534571 13.0307 0.534571C14.6151 0.534571 15.9973 1.43338 16.7333 2.76766C17.3917 2.46845 18.1049 2.31423 18.826 2.31511C21.6835 2.31511 24 4.69246 24 7.62511C24 10.558 21.6835 12.9353 18.826 12.9353C18.4773 12.9353 18.1365 12.8999 17.8069 12.832C17.1586 14.0084 15.9234 14.8032 14.5056 14.8032C13.9323 14.8039 13.3663 14.6714 12.851 14.4157C12.1939 15.9882 10.6629 17.0909 8.87857 17.0909C7.02046 17.0909 5.43694 15.8946 4.82902 14.2171C4.56345 14.2745 4.2882 14.3044 4.00583 14.3044C1.79355 14.3044 1.02592e-05 12.4608 1.02592e-05 10.1865C-0.00158342 9.46575 0.182522 8.75712 0.53398 8.13126C0.885437 7.50541 1.39197 6.98419 2.00311 6.61956C1.74934 6.02521 1.61874 5.38401 1.61947 4.736C1.61947 2.12034 3.70665 0 6.28116 0C7.79261 0 9.13589 0.731157 9.98743 1.86398",
    fill: "#00A1E0"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSalesforce24X18);
export default __webpack_public_path__ + "97131/static/media/Salesforce24x18.9cbda7a02fe71f462f58eb52f2982cf4.svg";
export { ForwardRef as ReactComponent };